/** Default Ant Design validateMessages keys for `_form.js` configs. */
export const DEFAULT_FORM_VALIDATION_MESSAGES = {
  required: 'form.error.required',
  types: {
    email: 'form.error.email',
    url: 'form.error.url',
  },
  string: {
    max: 'form.error.maxLength',
  },
};

/**
 * Merges shared defaults into a `_form.js` config export.
 * Forms only need to declare `fields` (and overrides when required).
 * Layout is owned by the form shell (e.g. ConfigFormDrawer uses vertical).
 */
export const withDefaultFormConfig = (config = {}) => ({
  ...config,
  validationMessages: {
    ...DEFAULT_FORM_VALIDATION_MESSAGES,
    ...(config.validationMessages || {}),
  },
});
